import { Company } from '@mirai-kids-monte/core/src/constants/Company';
import ExportedImage from 'next-image-export-optimizer';
import teacher from '../../../../public/img/yoko-smile.webp';
import styles from './index.module.scss';

export const Profile = () => (
  <>
    <h2>筆者のプロフィール</h2>
    <div className={styles.base}>
      <div className={styles['name-with-image']}>
        <ExportedImage
          src={teacher}
          className={styles.image}
          alt="講師の写真"
          loading="lazy"
          width={100}
          height={100}
        />
        <p className={styles.name}>{Company.CEO}</p>
      </div>
      <div>
        <ul className={styles['list-wrapper']}>
          <li>みらいキッズモンテプリスクール 園長</li>
          <li>モンテッソーリ教育幼稚園/保育園勤続 20 年</li>
          <li>日本モンテッソーリ協会ディプロマ取得</li>
          <li>幼稚園教諭免許</li>
          <li>保育士資格</li>
        </ul>
      </div>
    </div>
  </>
);
